module.exports = __webpack_public_path__ + "img/logo-27.3bc891d.jpg";